import Analytics from 'analytics';
import behaviorTrackingPlugin from './plugins/behaviorTrackingPlugin';

const analytics = Analytics({
  app:     'brazil_frontend',
  debug:   process.env.NODE_ENV === 'development',
  plugins: [
    behaviorTrackingPlugin(),
  ],
});

// Useful for debug purposes
window.analytics = analytics;

export default analytics;
